export default function Rocket() {
  return (
    <div
      className="axa-icon-icon-rocket"
      dangerouslySetInnerHTML={{
        __html: `
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
           width="54.000000pt" height="106.000000pt" viewBox="0 0 54.000000 106.000000"
           preserveAspectRatio="xMidYMid meet">

          <g transform="translate(0.000000,106.000000) scale(0.100000,-0.100000)"
          fill="#000000" stroke="none">
          <path d="M201 985 c-61 -76 -81 -122 -81 -185 0 -32 -4 -38 -43 -55 -24 -12
          -47 -32 -55 -47 -7 -15 -15 -78 -19 -140 -5 -96 -3 -115 10 -126 34 -28 52
          -11 57 54 5 57 21 94 41 94 5 0 9 -10 9 -23 0 -13 13 -35 28 -50 26 -25 35
          -27 109 -27 66 0 82 -3 87 -17 10 -24 -11 -33 -81 -33 -56 0 -63 2 -63 20 0
          11 -5 20 -11 20 -7 0 -9 -11 -6 -27 3 -15 -1 -40 -9 -54 -7 -15 -18 -48 -24
          -75 -10 -45 -9 -49 15 -71 14 -13 25 -32 25 -43 0 -28 11 -50 25 -50 13 0 47
          -71 60 -125 l7 -30 19 24 c10 13 19 30 19 37 0 8 7 26 16 39 10 16 14 34 10
          50 -5 18 -2 25 8 25 16 0 29 27 20 41 -3 6 0 16 6 24 7 8 15 44 17 79 5 52 2
          71 -17 108 l-22 44 33 52 c24 39 38 52 55 52 23 0 24 -4 24 -59 0 -43 4 -60
          15 -65 23 -8 32 19 45 137 11 96 10 110 -5 133 -17 27 -60 48 -82 40 -10 -4
          -13 8 -13 50 0 30 -7 71 -15 92 -15 35 -130 162 -147 162 -4 0 -35 -34 -67
          -75z m79 -10 c0 -41 -3 -75 -7 -75 -5 0 -7 34 -5 75 2 41 5 75 8 75 2 0 4 -34
          4 -75z m-23 18 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m52 -55
          c0 -21 -3 -38 -9 -38 -6 0 -10 28 -9 68 1 52 3 60 9 37 4 -16 8 -47 9 -67z
          m-78 2 l-9 -45 -1 46 c-1 25 2 49 6 53 12 12 13 -6 4 -54z m116 -17 c-3 -10
          -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-140 0 c-3 -10 -5 -4 -5 12 0
          17 2 24 5 18 2 -7 2 -21 0 -30z m171 -4 c-3 -8 -7 -3 -11 10 -4 17 -3 21 5 13
          5 -5 8 -16 6 -23z m-125 -39 c45 0 96 4 114 9 25 7 33 6 37 -6 8 -20 8 -185 0
          -260 l-7 -61 -55 -11 c-62 -12 -124 -14 -171 -5 l-31 7 0 142 c0 83 5 156 12
          176 6 18 13 28 16 21 2 -8 30 -12 85 -12z m-133 -201 c0 -67 -1 -72 -35 -103
          -32 -31 -35 -38 -35 -91 0 -41 -3 -55 -12 -52 -10 3 -13 36 -12 124 0 130 11
          164 57 183 36 14 37 13 37 -61z m374 50 c30 -24 32 -53 12 -189 -13 -83 -13
          -84 -15 -29 -1 60 -13 79 -48 79 -21 0 -22 2 -17 68 3 37 7 73 10 80 5 18 28
          15 58 -9z m-124 -209 c-21 -29 -24 -30 -104 -30 -74 0 -85 2 -105 24 l-23 24
          79 -5 c43 -2 96 0 118 5 22 6 44 10 48 11 5 1 -1 -12 -13 -29z m-127 -119 c-3
          -12 0 -11 11 3 9 11 19 16 23 13 10 -11 -37 -56 -58 -54 -16 1 -17 3 -4 17 21
          23 19 35 -2 19 -16 -12 -17 -12 -6 2 7 9 19 16 27 16 8 0 12 -7 9 -16z m52 -7
          c-9 -14 -14 -28 -11 -31 3 -3 13 8 23 26 10 17 21 31 25 31 16 0 2 -48 -26
          -90 -17 -25 -31 -48 -32 -52 -1 -5 -2 -14 -3 -20 -1 -9 -4 -8 -11 2 -17 27 -8
          93 18 128 29 38 41 43 17 6z m81 -77 c-3 -38 -10 -75 -16 -82 -6 -7 -8 -19 -4
          -28 3 -10 -2 -20 -15 -27 -16 -8 -20 -17 -15 -35 4 -16 0 -35 -10 -50 -9 -13
          -16 -32 -16 -42 0 -25 -14 -5 -34 50 -10 26 -26 52 -36 57 -12 6 -21 26 -26
          55 -5 35 -10 45 -25 45 -22 0 -24 18 -9 71 10 34 12 36 34 26 19 -9 25 -22 30
          -59 6 -46 33 -78 50 -60 4 4 15 7 24 7 10 0 16 7 16 18 -1 9 2 17 7 17 5 0 9
          18 9 39 0 22 5 43 11 47 6 3 9 18 6 32 -5 26 -5 26 10 7 11 -15 14 -37 9 -88z
          m-66 -47 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11
          -10z"/>
          <path d="M237 852 c-37 -40 -5 -92 55 -92 32 0 68 31 68 59 0 45 -91 69 -123
          33z m84 -2 c28 -16 24 -54 -7 -69 -32 -14 -60 -7 -74 20 -24 44 30 76 81 49z"/>
          <path d="M251 707 c-5 -7 -6 -19 -2 -26 11 -16 56 -10 56 8 0 19 -41 33 -54
          18z m39 -17 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4
          15 -10z"/>
          <path d="M305 363 c-11 -16 -20 -23 -23 -15 -4 14 -22 6 -22 -9 0 -6 5 -7 10
          -4 14 9 12 -8 -2 -25 -11 -12 -10 -12 5 0 23 17 61 70 54 76 -2 2 -12 -8 -22
          -23z"/>
          </g>
          </svg>
        `,
      }}
    />
  )
}
